export const environment = {
  production: false,
  localhost: false,
  apiUrl: '//staging.orderpod.app',
  ngswEnabled: false,
  privateKey: '0rd3rP0dst4g1ngfr0nt3nd139',
  configuration: 'web',
  sentryDsn:
    'https://50061d5ec8d944acb6005a30986bcedb@o4504236582305792.ingest.sentry.io/4504236584861699',
}
